module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"select":"Choisir","outward-journey":"Aller","return-journey":"Retour","price-from":"a partir de"},"en":{"select":"Select","outward-journey":"Outward journey","return-journey":"Return journey","price-from":"from"}}')
  delete Component.options._Ctor
}
